<template lang="pug">
	.campaigns-page
		header.campaigns-header
			.left-part
				button.btn.btn-primary.new-campaign(@click="showCreateNewCampaign")
					i.fa.fa-plus-square
					span New Campaign
				.time-filter
					.btn-group
						button.btn.btn-primary(v-for="timeFilter_ in timeFilters" @click="setTimeFilterInner(timeFilter_)") {{timeFilter_.charAt(0).toUpperCase() + timeFilter_.slice(1)}}
					DatePicker(:updateFunction="setTimeFilter" :parentName="'campaigns-page'" :timeFilter="timeFilterInner" :style="{'padding-left': '10px'}")
					CampaignPicker(:updateFunction="setCampaignsFilter")
		CampaignsTable(v-if="Object.keys(campaigns).length" :campaigns="campaigns" :timeFilter="timeFilter" :activeStatus="activeStatus")
</template>

<script>
	import Screen 				from './../../mixins/screen';
	import {Order} 				from "@/services/Order";

	import CampaignsTable 		from "@/components/Pages/CampaignsTable";

	import DatePicker 			from "@/components/CustomControls/DatePicker";
	import CampaignPicker 		from "@/components/CustomControls/CampaignPicker";

	export default {
		name: 'CampaignsPage',
		mixins: [Screen],
		screen: {
			updateOn: ["Campaigns Loaded"],
			events: {}
		},
		props: ['activeStatus'],
		components: {
			CampaignsTable,
			DatePicker,
			CampaignPicker
		},
		data() {
			this.Order = Order;
			return {
				showed: true,
				timeFilters: ['today', 'yesterday', 'last 3 days', 'last 7 days', 'this month', 'last month'],
				timeFilter: 'last 3 days',
				timeFilterInner: 'last 3 days',
				campaigns: {}
			}
		},
		methods: {
			collectData() {
				this.campaigns = Order.Campaigns;
				this.setTimeFilter(this.timeFilter);
			},

			showCreateNewCampaign() {
				Broadcast.call("Show CreateNewCampaign");
			},
			setTimeFilter(timeFilter) {
				this.timeFilter = timeFilter;
			},
			setTimeFilterInner(timeFilter) {
				this.timeFilterInner = timeFilter;
			},
			setCampaignsFilter(campaigns) {
				this.campaigns = _.filter(Order.Campaigns, campaign => campaigns.some(c => c.id === campaign.id));
			}
		}
	}

</script>

<style lang="sass">
.campaigns-page
	display: flex
	flex-direction: column
	overflow: hidden
	flex: 1

	.campaigns-table
		width: 100%
		display: flex
		flex: 1
		padding: 30px 30px 10px 30px
		color: white
		overflow: hidden
		min-height: 100px

	.campaigns-header
		display: flex
		flex-direction: column
		background-color: #2a2b36
		height: 60px
		justify-content: center

		.left-part
			display: flex
			flex-direction: row
			height: 40px
			padding-left: 15px

			.time-filter
				display: flex

				.btn-group > button
					color: black
					background-color: #66609d

					&:hover
						background-color: #8981C0

					&:focus
						box-shadow: unset
						background-color: #aba2e2
					&:active
						box-shadow: unset
						background-color: unset

				.btn-group > button:nth-child(1)
					border-top-left-radius: 15px
					border-bottom-left-radius: 15px
				.btn-group > button:nth-last-child(1)
					border-top-right-radius: 15px
					border-bottom-right-radius: 15px

			.new-campaign
				height: 100%
				color: #aaa1f5
				background-color: unset
				border: unset
				margin-right: 15px
				//border: unset
				//background: unset
				//padding: 0 30px 0 30px
				//border-radius: 5px

				>i
					padding-right: 5px

				&:hover
					background-color: #3a3b4a
					color: white
					border-radius: 10px
				&:focus
					box-shadow: unset

				&:active
					box-shadow: unset
					background-color: unset

</style>
